var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open === true)?_c('div',{staticClass:"bax-modal-wrap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"bax-modal-content-wrap bax-bg-foot-link"},[_c('div',{staticClass:"bax-modal-content bax-modal-icon-content text-center"},[_vm._t("default")],2)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }